import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const NostraFullLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo nostra__logo__nostraFullLogo"
      xmlns="http://www.w3.org/2000/svg"
      width="165"
      height="29"
      viewBox="0 0 166 30"
      fill="none"
    >
      <path
        d="M0 17.3869L12.8091 10.2755L0 3.16402V17.3869ZM15.9984 12.0447L0 20.9292L15.9984 29.8099L31.9967 20.9292V3.16402L15.9984 12.0485V12.0447ZM15.7948 0.132156L8.45821 4.32304L15.9984 8.51009L23.5345 4.32304L15.7988 0.135994L15.7948 0.132156Z"
        fill="#FF4240"
      />
      <path
        d="M55.2722 13.1536C54.2982 11.5264 52.9211 8.96273 52.0031 7.11675H51.9472C52.031 9.15846 52.0629 11.6953 52.0629 13.4299V20.6834H48.9375V4.13861H53.7554L57.4835 10.6168C58.6611 12.6585 59.9783 15.1378 60.8964 16.9569H60.9243C60.8964 15.0533 60.8684 13.0155 60.8684 11.3882V4.13861H63.9938V20.6796H59.7228L55.2762 13.1536H55.2722Z"
        fill="white"
      />
      <path
        d="M83.349 12.6854C83.349 9.51538 81.3971 6.97859 77.7847 6.97859C74.1723 6.97859 72.2204 9.51538 72.2204 12.6854C72.2204 16.1586 74.1404 18.5572 77.7847 18.5572C81.4291 18.5572 83.349 16.1586 83.349 12.6854ZM68.9792 12.7123C68.9792 7.77685 72.42 4.13861 77.7847 4.13861C83.1494 4.13861 86.6182 7.77685 86.6182 12.7123C86.6182 17.6477 83.3211 21.3972 77.7847 21.3972C72.2484 21.3972 68.9792 17.6746 68.9792 12.7123Z"
        fill="white"
      />
      <path
        d="M91.1125 15.5522L94.2659 14.9459C94.725 17.2908 96.3895 18.6685 99.0279 18.6685C101.235 18.6685 102.385 17.8396 102.385 16.5194C102.385 15.1992 101.383 14.4777 98.1418 14.0094C93.3798 13.2918 91.859 11.4458 91.859 8.93587C91.859 6.01146 94.0943 4.13861 98.2815 4.13861C102.812 4.13861 104.648 6.48351 105.307 9.51538L102.093 10.1486C101.551 7.96874 100.573 6.81356 98.1378 6.81356C96.2178 6.81356 95.156 7.63869 95.156 8.88214C95.156 9.98359 95.7867 10.7857 99.5748 11.3921C104.421 12.1366 105.714 14.067 105.714 16.4119C105.714 19.39 103.562 21.4011 98.8323 21.4011C93.6113 21.3742 91.5197 18.753 91.1165 15.5561"
        fill="white"
      />
      <path d="M109.813 4.13861H123.692V7.11675H118.387V20.6834H115.118V7.11675H109.813V4.13861Z" fill="white" />
      <path
        d="M131.851 6.92102V11.3345H135.751C137.731 11.3345 138.848 10.5055 138.848 9.01646C138.848 7.69242 138.046 6.92102 135.922 6.92102H131.851ZM134.717 14.1169H131.851V20.6796H128.582V4.13861H136.066C140.11 4.13861 142.061 5.93087 142.061 8.93587C142.061 11.584 140.656 13.2649 138.134 13.8713L143.183 20.6258V20.6796H139.223L134.721 14.1169H134.717Z"
        fill="white"
      />
      <path
        d="M153.565 14.0096H158.926L158.179 12.0792C157.549 10.5057 156.89 8.79783 156.343 7.22433H156.144C155.597 8.79783 154.938 10.5057 154.308 12.0792L153.561 14.0096H153.565ZM159.932 16.5732H152.531L150.927 20.6797H147.542L154.423 4.1349H158.151L165.033 20.6797H161.504L159.928 16.5732H159.932Z"
        fill="white"
      />
    </svg>
  );
};
export const NostraFullLogo = withLogo(NostraFullLogoComponent);
